import { render } from "./UpDown.vue?vue&type=template&id=38ba256d&scoped=true"
import script from "./UpDown.vue?vue&type=script&lang=js"
export * from "./UpDown.vue?vue&type=script&lang=js"

import "./UpDown.vue?vue&type=style&index=0&id=38ba256d&scoped=true&lang=css"

import exportComponent from "F:\\coding-project\\개발자품격\\제품판매웹앱구현\\카페24\\pro\\fastsell_login\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ba256d"]])

export default __exports__